import { debounce } from '@/utils/api';

// 管理日程渲染相关缓存与更新逻辑
export default {
	data() {
		return {
			// 存储当前需要渲染的日程日期。
			CURR_DATE_FOR_RENDERING: null,
			// 存储已缓存日程数据的月份键（YYYYMM 格式）。
			CACHED_SCHEDULE_MONTH_KEYS: [],
			ON_RENDER_UPDATE: null
		};
	},

	methods: {
		REGISTER_ON_RENDER_UPDATE(callback) {
			this.ON_RENDER_UPDATE = callback;
		},
		UPDATE_RENDERING_DATE(val) {
			this.CURR_DATE_FOR_RENDERING = val;
		},
		RESET_CACHED_SCHEDULE_MONTH_KEYS(val) {
			this.CACHED_SCHEDULE_MONTH_KEYS = val || [];
		},
		CLEAR_CACHED_SCHEDULE_MONTH_KEYS() {
			this.CACHED_SCHEDULE_MONTH_KEYS = [];
		},
		// 当 `date` 变化且对应的月份键不在缓存中时，触发视图刷新逻辑：更新 `currDateForRendering` 值并调用 `onRenderUpdate`（如果有提供）。
		UPDATE_SCHEDULE_RENDER: debounce(function (date) {
			const currDateKey = this.$moment(date).format('YYYYMM');
			if (!this.CACHED_SCHEDULE_MONTH_KEYS.includes(currDateKey)) {
				// 如果当前选中的日期没有记录数据 就需要触发视图刷新
				this.UPDATE_RENDERING_DATE(date);
				// 在视图需要刷新时触发外部更新操作。
				this.ON_RENDER_UPDATE?.();
			}
		}, 180)
	}
};
